import logger from '../utilities/logger'
import { decode } from 'js-base64';

const Oauth = {
  install(Vue, options) {
      Vue.prototype.$oauth = {
        createCookies: function (oauthData) {
          logger.log("createCookies", oauthData)
          const urlParams = new URLSearchParams(oauthData)
          var token = urlParams.get('access_token')
          Vue.$cookies.set('access_token', token, "3500s")
          Vue.$cookies.set('id_token', urlParams.get('id_token'), "3500s")
          var u = JSON.parse(decode(token.split('.')[1])).username
          Vue.$cookies.set('current_user', u, "3500s")
        },
        getCurrentUser: function () {
          var u = Vue.$cookies.get('current_user')
          return u
        },
        logOff(){
          logger.log("logOff")
          Vue.$cookies.remove('access_token')
          Vue.$cookies.remove('id_token')
          Vue.$cookies.remove('current_user')
          window.location.replace(options.baseOauthUrl + 'logout?response_type=token&client_id=' + options.clientId + '&redirect_uri=' + options.baseUrl + '&scope=openid%20email')
        },
        logIn(){
          logger.log("logIn")
          window.location.replace(options.baseOauthUrl + 'oauth2/authorize?response_type=token&client_id=' + options.clientId + '&redirect_uri=' + options.baseUrl + '&scope=openid%20email')
        }
      }
  }
};

export default Oauth;